module.exports = __webpack_public_path__ + "static/img/store1.9d61b81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/store1.jpg
// module id = wjlS
// module chunks = 1